import request from '@/utils/request'

export function selectMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `/api/serviceCenter/superword/selectMaterialType`,
        method: 'post',
        data,
    })
}

export function superwordSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superword/superwordSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function superwordBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superword/superwordBatchDelete?`,
        method: 'post',
        data,
    })
}

export function updateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superword/updateComposition?`,
        method: 'post',
        data,
    })
}

export function updateUnComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superword/updateUnComposition?`,
        method: 'post',
        data,
    })
}

export function unDownLoad(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superword/unDownLoad?`,
        method: 'post',
        data,
    })
}
